import React, { useState, useEffect } from "react";

import { algoliasearch } from "algoliasearch";

import Box from "@mui/material/Box";

import { SearchHit } from "../Home/SearchHit";

export function LatLngSearch(props) {
  const [hits, setHits] = useState(null);
  const appID = "4QC6DKEQDN";
  const apiKey = "266e2d468394f84445aeba796968f816";
  const indexName = "stops-index";

  //   if (!props.position.latitude || !props.position.longitude) {
  //     console.error("position error");
  //     return;
  //   }

  const latlng = props.position.latitude + "," + props.position.longitude;
  // const latlng = "35.5323948181508,139.69874077440727";

  const client = algoliasearch(appID, apiKey);

  async function fetchData() {
    const response = await client.searchSingleIndex({
      indexName: indexName,
      searchParams: {
        aroundLatLng: latlng,
        aroundRadius: 1000,
      },
    });
    // console.log(response.hits);
    setHits(response.hits);
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {hits && hits.map((hit) => <SearchHit hit={hit} key={hit.objectID} />)}
      {hits && hits.length === 0 && (
        <Box sx={{ m: 2 }}>近くに登録されたバス停がありません</Box>
      )}
    </>
  );
}
